import React from "react";
import { DivColumn, DivRow, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import UtilsUnit from "../../../utils/UtilsUnit";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";
import "./WidgetAlertDialogChangeRequestDetails.css";

const WidgetAlertDialogChangeRequestDetails = ({
  changeRequest,
  onClose,
  onApprove,
  onReject,
  isApproving,
  isRejecting,
}) => {
  if (!changeRequest) {
    return null;
  }

  const isBusy = !!isApproving || !!isRejecting;

  const yearOfNeedBefore = changeRequest.yearOfNeedBefore ?? "";
  const yearOfNeedAfter = changeRequest.yearOfNeedAfter ?? "";
  const feasibilityBefore = changeRequest.feasibilityPositionBefore ?? changeRequest.feasibilityBefore;
  const feasibilityAfter = changeRequest.feasibilityPositionAfter ?? changeRequest.feasibilityAfter;

  const hasUrgencyChanged =
    yearOfNeedBefore !== "" && yearOfNeedAfter !== "" && String(yearOfNeedBefore) !== String(yearOfNeedAfter);
  const hasFeasibilityChanged =
    feasibilityBefore != null &&
    feasibilityAfter != null &&
    feasibilityBefore !== "" &&
    feasibilityAfter !== "" &&
    Number(feasibilityBefore) !== Number(feasibilityAfter);

  const requesterLabel = `${ConstantsTexts.CODE_270}${changeRequest.requestedByUserName || ""}`;
  const requestedAtLabel = changeRequest.requestedAt
    ? `${UtilsUnit.formatDate(changeRequest.requestedAt)}, ${UtilsUnit.formatDateHour(changeRequest.requestedAt)}`
    : "";

  return (
    <div className="alert-dialog-change-request-details-overlay" onClick={isBusy ? undefined : onClose}>
      <DivColumn className="alert-dialog-change-request-details" onClick={(event) => event.stopPropagation()}>
        <DivRow className="alert-dialog-change-request-details-close-row">
          <button
            type="button"
            className="alert-dialog-change-request-details-close"
            onClick={onClose}
            aria-label="סגירה"
            disabled={isBusy}
          >
            <WidgetIconFive iconProp={ConstantsImages.PENDING_REQUESTS_CLOSE_IMAGE} widthIconProp="1rem" heightIconProp="1rem" />
          </button>
        </DivRow>

        <ParagraphText className="alert-dialog-change-request-details-title">{ConstantsTexts.CODE_267}</ParagraphText>
        <ParagraphText className="alert-dialog-change-request-details-requester">{requesterLabel}</ParagraphText>
        <ParagraphText className="alert-dialog-change-request-details-datetime">{requestedAtLabel}</ParagraphText>

        {hasUrgencyChanged &&
          changeSection({
            title: ConstantsTexts.CODE_35,
            subtitle: ConstantsTexts.CODE_274,
            beforeValue: UtilsUnit.formatYearOfNeedLabel(yearOfNeedBefore),
            afterValue: UtilsUnit.formatYearOfNeedLabel(yearOfNeedAfter),
          })}

        {hasFeasibilityChanged &&
          changeSection({
            title: ConstantsTexts.CODE_36,
            subtitle: ConstantsTexts.CODE_275,
            beforeValue: UtilsUnit.getGaugeNumberText(feasibilityBefore),
            afterValue: UtilsUnit.getGaugeNumberText(feasibilityAfter),
          })}

        <DivColumn className="alert-dialog-change-request-details-note">
          <ParagraphText className="alert-dialog-change-request-details-note-title">{ConstantsTexts.CODE_276}</ParagraphText>
          <ParagraphText className="alert-dialog-change-request-details-note-text">{changeRequest.reason}</ParagraphText>
        </DivColumn>

        <DivRow className="alert-dialog-change-request-details-actions">
          <button type="button" className="alert-dialog-change-request-details-reject" onClick={onReject} disabled={isBusy || !onReject}>
            <WidgetIconFive iconProp={ConstantsImages.CHANGE_REQUEST_REJECT_IMAGE} widthIconProp="1.8rem" heightIconProp="1.8rem" />
            <ParagraphText className="alert-dialog-change-request-details-action-text">{ConstantsTexts.CODE_277}</ParagraphText>
          </button>
          <button type="button" className="alert-dialog-change-request-details-approve" onClick={onApprove} disabled={isBusy || !onApprove}>
            <WidgetIconFive iconProp={ConstantsImages.CHANGE_REQUEST_APPROVE_IMAGE} widthIconProp="1.8rem" heightIconProp="1.8rem" />
            <ParagraphText className="alert-dialog-change-request-details-action-text">{ConstantsTexts.CODE_278}</ParagraphText>
          </button>
        </DivRow>
      </DivColumn>
    </div>
  );

  function changeSection({ title, subtitle, beforeValue, afterValue }) {
    return (
      <DivColumn className="alert-dialog-change-request-details-section">
        <ParagraphText className="alert-dialog-change-request-details-section-title">{title}</ParagraphText>
        <ParagraphText className="alert-dialog-change-request-details-section-subtitle">{subtitle}</ParagraphText>
        <DivRow className="alert-dialog-change-request-details-chips">
          <div className="alert-dialog-change-request-details-chip alert-dialog-change-request-details-chip-after">
            <ParagraphText className="alert-dialog-change-request-details-chip-after-text">{afterValue}</ParagraphText>
          </div>
          <WidgetIconFive iconProp={ConstantsImages.CHANGE_REQUEST_ARROW_IMAGE} widthIconProp="1.8rem" heightIconProp="0.6rem" />
          <div className="alert-dialog-change-request-details-chip alert-dialog-change-request-details-chip-before">
            <ParagraphText className="alert-dialog-change-request-details-chip-before-text">{beforeValue}</ParagraphText>
          </div>
        </DivRow>
      </DivColumn>
    );
  }
};

export default WidgetAlertDialogChangeRequestDetails;
